import * as React from 'react';
import { Coords } from 'google-map-react';

interface MapContextValues {
    mapCenter?: Coords;
    mapZoom?: number;
    setMapCenter: (center: Coords) => void;
    setMapZoom: (zoom: number) => void;
}

export const MapContext = React.createContext<MapContextValues>({
    mapCenter: undefined,
    mapZoom: undefined,
    setMapCenter: () => {},
    setMapZoom: () => {},
});
